export const validatePhoneNumber = (value) => {
  let error;
  if (!value) {
    error = 'Phone number is required';
  } else {
    const digitsOnly = value.replace(/[^\d]/g, '');
    const hasCountryCode = value.trim().startsWith('+1');
    const isValidFormat = /^[\d\-+().](\s?[\d\-+().])*$/.test(value);
    
    if (!isValidFormat || (hasCountryCode && digitsOnly.length < 11) || (!hasCountryCode && digitsOnly.length < 10)) {
      error = 'Please enter a valid 10 digit phone number';
    }
  }
  return error;
};